import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBrain,
  faLightbulb,
  faExclamationTriangle,
  faArrowTrendUp,
  faInfoCircle
} from '@fortawesome/free-solid-svg-icons';

export interface InsightItem {
  type: 'insight' | 'recommendation' | 'warning' | 'prediction' | string;
  title: string;
  message: string;
  confidence?: number;
}

interface InsightsListProps {
  insights: ReadonlyArray<InsightItem>;
}

const iconMap: Record<string, { icon: any; color: string; bg: string }> = {
  insight: { icon: faLightbulb, color: 'text-blue-400', bg: 'bg-blue-500/20' },
  recommendation: { icon: faBrain, color: 'text-purple-400', bg: 'bg-purple-500/20' },
  warning: { icon: faExclamationTriangle, color: 'text-yellow-400', bg: 'bg-yellow-500/20' },
  prediction: { icon: faArrowTrendUp, color: 'text-green-400', bg: 'bg-green-500/20' },
  default: { icon: faInfoCircle, color: 'text-white/70', bg: 'bg-white/10' }
};

const InsightsList: React.FC<InsightsListProps> = ({ insights }) => {
  if (!insights || insights.length === 0) {
    return null;
  }

  return (
    <div className="mt-6 space-y-3">
      <div className="flex items-center space-x-2">
        <FontAwesomeIcon icon={faBrain} className="text-purple-400 text-lg" />
        <h4 className="text-lg font-semibold text-white">AI Analizi</h4>
      </div>
      <div className="space-y-3">
        {insights.map((insight, index) => {
          const meta = iconMap[insight.type] ?? iconMap.default;
          return (
            <div key={`${insight.title}-${index}`} className="backdrop-blur-xl bg-white/5 border border-white/10 rounded-xl p-4">
              <div className="flex items-start space-x-3">
                <div className={`w-9 h-9 rounded-full flex items-center justify-center ${meta.bg}`}>
                  <FontAwesomeIcon icon={meta.icon} className={`${meta.color} text-sm`} />
                </div>
                <div className="flex-1">
                  <div className="flex items-center space-x-2">
                    <h5 className="text-white font-medium">{insight.title}</h5>
                    {typeof insight.confidence === 'number' && (
                      <span className="text-xs text-white/50">
                        Güven: {(insight.confidence * 100).toFixed(0)}%
                      </span>
                    )}
                  </div>
                  <p className="text-white/70 text-sm leading-relaxed">{insight.message}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InsightsList;

